import React from 'react';
import classNames from 'classnames';

import './Popup.css';

export default function Popup(props) {
  return (
    <div className={classNames('popupContainer', props.className)} ref={props.innerRef}>
      <div className="overlay popupOverlay" onClick={props.closePopup}></div>
      <div className="frame popupFrame">
        {props.children}
      </div>
    </div>
  );
}
